// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-i_hq","catalogByServiceItem__title":"c-i_hr"};